import axios from "./requestWrapper";

const apiUrl = process.env.VUE_APP_API_URL;

const orderService = {
  handleResponse(response) {
    return new Promise((res, rej) => {
      if (response.data.error) {
        rej(response.data.error);
      } else {
        res(response.data);
      }
    });
  },

  getEarnings(month, year) {
    return axios
      .get(`${apiUrl}/orders/earnings?month=${month}&year=${year}`)
      .then(orderService.handleResponse);
  },

  getOrders(from, to) {
    return axios
      .get(`${apiUrl}/orders/list?from=${from}&to=${to}`)
      .then(orderService.handleResponse);
  },

  makeOrder(address, cart) {
    return axios
      .post(`${apiUrl}/orders/add`, {
        address,
        cart
      })
      .then(orderService.handleResponse);
  }
};

export default orderService;
